import React, { useEffect, useState } from "react";
import { toast } from "./ui/sonner";
import { useApp } from "../context/AppContext";
import { CheckCircle2, Loader2, MessageSquarePlus, PhoneCall } from "lucide-react";

/* 铃铛内联「记一笔联系」：aftersales_stale 提醒列出的前 5 个完工项目，直接选渠道 + 备注提交，不必打开清单 */
export const StaleContactInline = ({ reminder, compact = false, onAllDone }) => {
  const { api, lang } = useApp();
  const zh = lang === "zh";
  const [d, setD] = useState(null);
  const [denied, setDenied] = useState(false);
  const [open, setOpen] = useState(null); // projectId
  const [form, setForm] = useState({ channel: "phone", note: "" });
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/aftersales/stale-reminder/bell/${reminder.id}`).then((r) => setD(r.data)).catch(() => setDenied(true));
  useEffect(() => { load(); }, [reminder.id]); // eslint-disable-line
  if (denied) return null;
  if (!d) return <p className="text-[10px] text-slate-400"><Loader2 className="h-3 w-3 animate-spin inline" /></p>;
  const items = d.items || [];
  const done = items.filter((x) => x.contactedAt).length;
  const save = async (e, pid) => {
    e.stopPropagation();
    if (!form.note.trim()) { toast.error(zh ? "请填写一句联系内容" : "Note required"); return; }
    setBusy(true);
    try {
      await api.post(`/aftersales/customers/${pid}/contact`, form);
      toast.success(zh ? "已记录联系" : "Contact logged");
      setOpen(null); setForm({ channel: "phone", note: "" });
      const { data } = await api.get(`/aftersales/stale-reminder/bell/${reminder.id}`);
      setD(data);
      if ((data.items || []).every((x) => x.contactedAt)) onAllDone?.();
    } catch (err) { toast.error(err?.response?.data?.detail || (zh ? "记录失败" : "Failed")); } finally { setBusy(false); }
  };
  const sz = compact ? "text-[10px]" : "text-[11px]";
  return (
    <div className={`space-y-1 ${sz}`} data-testid={`stale-inline-${reminder.id}`} data-done={done} data-total={items.length} onClick={(e) => e.stopPropagation()}>
      <p className="text-slate-500 inline-flex items-center gap-1"><PhoneCall className="h-3 w-3" />{zh ? `前 ${items.length} 个 · 已联系 ${done}/${items.length}` : `Top ${items.length} · contacted ${done}/${items.length}`}</p>
      {items.map((it) => (
        <div key={it.id} className="rounded-lg border border-slate-100 bg-white px-2 py-1" data-testid={`stale-inline-item-${it.id}`} data-contacted={it.contactedAt ? 1 : 0}>
          <div className="flex items-center gap-2">
            <span className="min-w-0 truncate text-slate-700 font-medium">{it.address}</span>
            {it.clientName && <span className="text-slate-400 truncate hidden sm:inline">{it.clientName}</span>}
            {it.contactedAt ? (
              <span className="ml-auto inline-flex items-center gap-1 text-emerald-600 font-semibold shrink-0" data-testid={`stale-inline-done-${it.id}`}><CheckCircle2 className="h-3 w-3" />{zh ? "已联系" : "Done"}{it.channelLabel ? ` · ${it.channelLabel}` : ""}</span>
            ) : d.canContact ? (
              <button type="button" data-testid={`stale-inline-contact-${it.id}`} onClick={(e) => { e.stopPropagation(); setOpen(open === it.id ? null : it.id); }}
                className={`ml-auto inline-flex items-center gap-1 rounded-full px-2 py-0.5 font-semibold shrink-0 ${open === it.id ? "bg-slate-200 text-slate-700" : "bg-amber-600 hover:bg-amber-700 text-white"}`}>
                <MessageSquarePlus className="h-3 w-3" />{zh ? "记一笔联系" : "Log contact"}
              </button>
            ) : null}
          </div>
          {open === it.id && (
            <div className="mt-1 flex flex-wrap items-center gap-1.5" data-testid={`stale-inline-form-${it.id}`}>
              <select className="border border-slate-300 rounded-md px-1.5 py-0.5 bg-white" value={form.channel} onChange={(e) => setForm({ ...form, channel: e.target.value })} data-testid={`stale-inline-channel-${it.id}`}>
                {Object.entries(d.channels || {}).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </select>
              <input className="flex-1 min-w-[120px] border border-slate-300 rounded-md px-2 py-0.5 bg-white" placeholder={zh ? "一句话：客户反馈 / 下次跟进" : "Note"} value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} onKeyDown={(e) => e.key === "Enter" && save(e, it.id)} data-testid={`stale-inline-note-${it.id}`} />
              <button type="button" disabled={busy} onClick={(e) => save(e, it.id)} className="rounded-md bg-emerald-600 hover:bg-emerald-700 text-white px-2 py-0.5 font-semibold disabled:opacity-50" data-testid={`stale-inline-save-${it.id}`}>{busy ? <Loader2 className="h-3 w-3 animate-spin" /> : (zh ? "保存" : "Save")}</button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
